import devicesFrameDark from "../../../assets/home/frame_dark.png";
import mobileContent from "../../../assets/home/mobile_anim.webp";
import tabletContent from "../../../assets/home/tablet_anim.webp";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";

export function WelcomeDevicesPreview() {
  const isCompactView = useIsCompactView();

  return (
    <div
      className={`${
        isCompactView
          ? "w-[60%] max-w-[425px]"
          : `max-w-[min(450px,40vw)] w-full pl-[15%]`
      } flex flex-row items-end justify-center 
      overflow-x-hidden z-20 relative`}
    >
      <img
        src={tabletContent}
        className={`absolute w-full h-full z-0 ${
          !isCompactView && "pl-[8%] pr-[9%]"
        }`}
      />
      <img
        src={mobileContent}
        className={`absolute w-full h-full z-0 ${
          !isCompactView && "pl-[6%] pr-[7%]"
        }`}
      />
      <img
        src={devicesFrameDark}
        alt="Devices Preview"
        className="w-full h-full z-20"
      />
    </div>
  );
}
